import { useState, useEffect } from 'react';

const useResize = () => {
	const getDeviceType = width => {
		if (width >= 1024) return 'desktop';
		if (width >= 768) return 'tablet';
		return 'mobile';
	};

	const [deviceType, setDeviceType] = useState(getDeviceType(window.innerWidth));

	useEffect(() => {
		const handleResize = () => {
			setDeviceType(getDeviceType(window.innerWidth));
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return deviceType;
};

export default useResize;
